import {
  requestGet,
} from "../config/Api";

export function getParties(params = {}) {
  return requestGet("/parties", { params });
}

export function getPartyLegalFiles(partyId, params = {}) {
  return requestGet(`/parties/${partyId}/legal/files`, { params });
}